module.exports = __webpack_public_path__ + "img/bluesky3100_12.612f9572.jpg";